import { format, isBefore, parse, startOfDay } from 'date-fns';

const DATE_STRING_ISO_FORMAT = 'yyyy-MM-dd';
const DATE_DISPLAY_FORMAT = 'dd/MM/yyyy';
const DATETIME_DISPLAY_FORMAT = 'dd/MM/yyyy HH:mm';

export const formatDateStringIso = (date: Date): string => {
  return format(date, DATE_STRING_ISO_FORMAT);
};

export const formatDateDisplay = (date: Date): string => {
  return format(date, DATE_DISPLAY_FORMAT);
};

export const formatDateTimeDisplay = (date: Date): string => {
  return format(date, DATETIME_DISPLAY_FORMAT);
};

/**
 * Parses a date string in YYYY-MM-DD format to a Date object in local time.
 * This avoids the timezone issue where `new Date("2025-12-18")` is parsed as UTC.
 *
 * @param dateString - A date string in YYYY-MM-DD format
 * @returns A Date object representing midnight local time on that date
 */
export const parseDateString = (dateString: string): Date => {
  return parse(dateString, DATE_STRING_ISO_FORMAT, new Date());
};

/**
 * Returns today's date at midnight (start of day).
 * Use this for date comparisons to avoid time component issues.
 *
 * @returns Today's date at 00:00:00.000
 */
export const getToday = (): Date => {
  return startOfDay(new Date());
};

/**
 * Checks if a date is today or in the future (not in the past).
 * Compares dates only, ignoring time components.
 *
 * @param date - The date to check
 * @returns true if the date is today or later, false if in the past
 */
export const isDateTodayOrFuture = (date: Date): boolean => {
  return !isBefore(startOfDay(date), getToday());
};
